import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
// vyzadovano kvuli vazbam na jQuery eventy z validace
import $ from 'jquery';

const fragment = {
  RADIO_TARGET: '[data-sss-fragment="ScramjetScaleSelect.radioTarget"]',
};

class ScramjetScaleSelect extends WebComponent {

  constructor(props) {
    super(props);
    this.handleRadioClick = this.handleRadioClick.bind(this);
    this.handleRadioLoad = this.handleRadioLoad.bind(this);
  }

  didMount() {
    this.on('click', this.handleRadioClick);
    $(window).on('validationFailed', this.handleRadioLoad);
    $(window).on('validationPassed', this.handleRadioLoad);
  }

  willUnMount() {
    $(window).off('validationPassed', this.handleRadioLoad);
    $(window).off('validationFailed', this.handleRadioLoad);
  }

  handleRadioClick(e) {
    const {
      activeClassName,
    } = this.props;
    const radio = e.target === this.element.querySelector(fragment.RADIO_TARGET);
    const input = e.target.parentNode.querySelector('.form-control');

    if (radio || input) {
      e.target.parentNode.classList.add(activeClassName);
    } else {
      const radioContainer = this.element.querySelector('.radio.active');
      if (radioContainer) {
        radioContainer.classList.remove(activeClassName);
      }
    }
  }

  handleRadioLoad() {
    const {
      activeClassName,
    } = this.props;
    const radioTargets = document.querySelectorAll(fragment.RADIO_TARGET);

    radioTargets.forEach((radioTarget) => {
      if (radioTarget.checked === true) {
        radioTarget.parentNode.classList.add(activeClassName);
      }
    });
  }

}

ScramjetScaleSelect.defaultProps = {
  activeClassName:'active',
};

export default ScramjetScaleSelect;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ScramjetScaleSelect.js